import { Component, Directive, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BillingPortalProps } from '../../models/BillingPortalProps';
import { BansStorageService } from '../../services/bans-storage.service';

interface IDispute {
  BusinessPartner: string;
  CaseID: string;
  DisputeCaseCurrency: string;
  DisputedAmount: any;
  CaseCreationDate: any;
  CADisputeTypeText: string;
  CaseStatusName: string;
}

export type SortColumn = keyof IDispute | '';
export type SortDirection = 'asc' | 'desc' | '';

const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };
const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}

@Directive({
  selector: 'th[sortable]',
  host: {
    '[class.asc]': 'direction === "asc"',
    '[class.desc]': 'direction === "desc"',
    '(click)': 'rotate()'
  }
})

export class NgbdSortableHeader {

  @Input() sortable: SortColumn = '';
  @Input() direction: SortDirection = '';
  @Output() sort = new EventEmitter<SortEvent>();

  rotate() {
    this.direction = rotate[this.direction];
    this.sort.emit({ column: this.sortable, direction: this.direction });
  }
}

@Component({
  selector: 'app-mydispute',
  templateUrl: './mydispute.component.html',
  styleUrls: ['./mydispute.component.css']
})

export class MydisputeComponent implements OnInit {

  @Input() token: string = 'initial token!';

  @ViewChildren(NgbdSortableHeader) headers!: QueryList<NgbdSortableHeader>;

  backendSystemData: any;
  userDataDto: any;
  systemName = localStorage.getItem("backendSystemName");
  bpNo: any;
  disputeData: Array<any> = [];
  AlldisputeData: Array<any> = [];
  banCAs = new Map<string, Array<string>>();
  ban: string = "";
  customerIDs: Array<string> = [];
  isLoading = false;
  currentPage = 1;
  itemsPerPage = environment.itemsPerPage;
  banflag: boolean = false;
  isAllDataLoaded: boolean = true;
  unSupportedBanDispute: boolean = false;

  BillingPortalProps: BillingPortalProps = new BillingPortalProps();
  toggleLoading = () => this.isLoading = !this.isLoading;

  constructor(
    private http: HttpClient,
    private bansService: BansStorageService
  ) { }

  async ngOnInit(): Promise<void> {
    this.getBans();
  }

  getBans() {
    this.bansService.bans.subscribe((bans: any) => {
      if (bans) {
        this.banCAs = bans;
        let ban = JSON.parse(JSON.stringify(localStorage.getItem("Selected_BAN_Dropdown_Value"))) || "";
        let firstBAN: any = this.banCAs.entries().next().value;
        this.ban = ban ? ban : firstBAN[0];
        this.getDisputeDetailsFromBRIM(this.ban);
      }
      else {
        this.bansService.banFlag.subscribe(
          (isPresent: boolean) => {
            if (!isPresent) {
              this.AlldisputeData = []
              this.disputeData = [];
              this.unSupportedBanDispute = true;
            }
          });
      }
    })
  }

  selectedBan() {
    if (this.ban != "BAN") {
      this.getDisputeDetailsFromBRIM(this.ban);
    }
  }

  selectBan(selectedBan: string): void {
    this.ban = selectedBan;
    if (this.ban != "BAN") {
      this.getDisputeDetailsFromBRIM(this.ban);
    }
    this.resetLoadMoreButton();
  }

  resetLoadMoreButton() {
    if (this.disputeData.length === this.AlldisputeData.length) {
      this.isAllDataLoaded = true;
    } else {
      this.isAllDataLoaded = false;
    }
  }

  async getDisputeDetailsFromBRIM(banNo: any) {
    this.banflag = false;
    this.AlldisputeData = new Array();
    let logTraceJSON: any = { 'eventSource': 'getDisputeListDetails', 'ban': banNo };
    const headers = new HttpHeaders({
        'X-Log-Trace': JSON.stringify(logTraceJSON),
    });
    this.http.get(environment.serverURL + environment.brimURI + 'disputeDetails/' + banNo, {headers}).subscribe((res: any) => {
      res.value.forEach((element: any) => {
        if (this.AlldisputeData.findIndex((item) => item.CaseID === element.CaseID) < 0) {
          this.AlldisputeData.push(element);
        }
      });
      this.banflag = true;
      this.disputeData = this.AlldisputeData.sort((a: any, b: any) => <any>b.CaseID - <any>a.CaseID);
      this.AlldisputeData = this.disputeData.filter((item, index, self) => self.indexOf(item) === index);
      this.disputeData = this.AlldisputeData.slice(0, this.itemsPerPage);
      this.resetLoadMoreButton();
    }, (err: { errorMessage: any; }) => {
      console.log(err.errorMessage);
    });
  }

  loadMoreDisputes() {
    if (this.disputeData.length < this.AlldisputeData.length) {
      this.appendData();
    } else {
      this.isAllDataLoaded = true;
    }
  }

  appendData() {
    this.disputeData = [...this.AlldisputeData];
    this.resetLoadMoreButton();
  }

  onSort({ column, direction }: SortEvent) {
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction === '' || column === '') {
      this.disputeData = this.AlldisputeData.slice(0, this.disputeData.length);
    } else {
      this.AlldisputeData = [...this.AlldisputeData].sort((a, b) => {
        if (column.toLocaleLowerCase().includes("date")) {
          if (direction === 'asc')
            return new Date(b[column]).getTime() - new Date(a[column]).getTime();
          else
            return new Date(a[column]).getTime() - new Date(b[column]).getTime();
        } else {
          const res = compare(a[column], b[column]);
          return direction === 'asc' ? res : -res;
        }
      });
      this.disputeData = this.AlldisputeData.slice(0, this.disputeData.length);
    }
  }

  downloadCSV() {
    if (this.AlldisputeData.length) {
      let data = this.makeCSV(this.AlldisputeData);
      this.fileDownload(data);
    }
  }

  fileDownload(data: any) {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', `${this.ban}-Dispute-List.csv`);
    a.click();
  }

  makeCSV(data: any) {
    const columnMapping: { [key: string]: string } = {
      cadisputeCase: "Dispute Case ID",
      caseType: "Case Type",
      caseID: "Case ID",
      caseStatus: "Case Status",
      caseStatusName: "Case Status Name",
      disputeCasePriorityName: "Priority",
      caseCategory: "Case Category",
      disputeCaseCategoryName: "Dispute Case Category",
      caseReasonName: "Case Reason",
      cadisputeTypeText: "Dispute Type",
      contractAccount: "Contract Account",
      businessPartner: "Business Partner",
      cadisputeType: "Dispute Type Code",
      disputedAmount: "Disputed Amount",
      disputeCaseCurrency: "Currency",
      invoiceNumber: "Invoice Number",
      caseUUID: "Case UUID",
      caseCreationDate: "Case Creation Date",
      totalReceivablesAmount: "Total Receivables Amount"
    };
    const headers = Object.keys(columnMapping);
    const csvContent = [];
    csvContent.push(Object.values(columnMapping).join(','));
    data.forEach((item: any) => {
      const row: any = [];
      headers.forEach(header => {
        let value = item[header];
        if (typeof value === 'string' && value.includes(',')) {
          value = `"${value}"`;
        }
        row.push(value);
      });
      csvContent.push(row.join(','));
    });
    return csvContent.join('\n');
  }
}
